export default __webpack_public_path__ + "static/media/151-cooling.741e1f60.png";